<h1 class="text-white text-lg font-semibold mb-4">Gestión de Roles</h1>
<div class="mb-4">
    <button matButton (click)="onCreateRole()" *ngIf="canCreateRole$ | async">Crear Nuevo Role</button>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay roles registrados.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
            <td mat-cell *matCellDef="let role"> {{ role.id }} </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let role"> {{ role.name }} </td>
        </ng-container>
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let role"> {{ role.active ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let role">{{ role.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let role">
                <button mat-icon-button color="accent" aria-label="Editar role" (click)="onEditRole(role)" *ngIf="canEditRole$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar role" (click)="onDeleteRole(role.id)" *ngIf="canDeleteRole$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
</div>